import React, { Component } from 'react';
import { connect } from 'react-redux';

import Spinner from '../../../components/UI/Spinner/Spinner';
import classes from './PauseScheduleForm.css';
import axios from '../../../axios-local-api';
import Box from '../../../hoc/Box/Box';
import WeekDays from '../../../components/UI/WeekDays/WeekDays';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../../store/actions/index';
import Switch from '../../../components/UI/Switch/Switch';
import { FaSync } from 'react-icons/fa';
import Modal from '../../../components/UI/Modal/Modal';
import Confirm from '../../../components/UI/Confirm/Confirm';
import Select from 'react-select'
import SelectDropdown from '../../../shared/SelectDropdown/SelectDropdown';

const hoursOptions = [
{label:'01', value: '01'},
{label:'02', value: '02'},
{label:'03', value: '03'},
{label:'04', value: '04'},
{label:'05', value: '05'},
{label:'06', value: '06'},
{label:'07', value: '07'},
{label:'08', value: '08'},
{label:'09', value: '09'},
{label:'10', value: '10'},
{label:'11', value: '11'},
{label:'12', value: '12'}
];
const minutesOptions =[
  {label:'00', value: '00'},
  {label:'15', value: '15'},
  {label:'30', value: '30'},
  {label:'45', value: '45'}
];
const ampmOptions =[{label:'AM', value: 'AM'}, {label:'PM', value: 'PM'}];

class PauseScheduleForm extends Component {
  constructor(props) {
    super(props);
    this.days = {
      monday: 1,
      tuesday: 2,
      wednesday: 3,
      thursday: 4,
      friday: 5,
      saturday: 6,
      sunday: 7,
    };
    this.daysByID = Object.keys(this.days).reduce((acc, key) => {
      acc[this.days[key]] = key;
      return acc;
    }, {});

    this.state = {
      scheduleName: '',
      startTime: '12:00 AM',
      endTime: '11:45 PM',
      startHour: '12',
      startMinute: '00',
      startAMPM: 'AM',
      endAMPM: 'PM',
      endMinute: '45',
      endHour: '11',
      enableSchedule: this.props.template && this.props.template.hasOwnProperty('enable') ? this.props.template.enable : true,
      selectedDays: [],
      resetValue: false,
      days: {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
      },
      editFormDisable: false,
      isEditingName: false,
      isValid: true,
      isFocused: false,
      renderKey: 0,
    };
    this.editFormDisable = false;
    this.editFormData = {};
    this.handleScheduleNameChange = this.handleScheduleNameChange.bind(this);
    this.handleToggleEnableSchedule =
      this.handleToggleEnableSchedule.bind(this);
    this.handleWeekDaysChange = this.handleWeekDaysChange.bind(this);
    this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
    this.handleEndTimeChange = this.handleEndTimeChange.bind(this);
    this.handleClearSchedule = this.handleClearSchedule.bind(this);
    this.compareTime = this.compareTime.bind(this);
    this.handleResetValue = this.handleResetValue.bind(this);
    this.updateEndTime = this.updateEndTime.bind(this);
    this.convertTime12to24 = this.convertTime12to24.bind(this);
    this.assignTime = this.assignTime.bind(this);
    this.convertTo12Hour = this.convertTo12Hour.bind(this);
    this.calculateEstimatedDuration =
      this.calculateEstimatedDuration.bind(this);
    this.handleScheduleTimings = this.handleScheduleTimings.bind(this);
    this.prepareMultiScheduleForApi =
      this.prepareMultiScheduleForApi.bind(this);
  }

  componentDidMount() {
    const templateCopy = Object.assign({}, this.props.template);
    // console.log('templateCopy', templateCopy);
    if (templateCopy) {
      this.state.scheduleName = templateCopy.name || '';
      if (templateCopy.customSchedules && templateCopy.customSchedules.length) {
        let schedule = Object.assign({}, templateCopy.customSchedules);
        this.state.startTime = schedule[0].startTime;
        this.state.endTime = schedule[1]
          ? schedule[1].endTime
          : schedule[0].endTime == null
            ? '00:00'
            : schedule[0].endTime;
        if (schedule[0].daysOfWeek) {
          this.state.selectedDays = schedule[0].daysOfWeek.map(
            (d) => this.daysByID[d]
          );
        }
        this.editFormData = {
          selectedDays: this.state.selectedDays,
          scheduleName: this.state.scheduleName,
        };
        this.assignTime(this.state.startTime, 'start');
        this.assignTime(this.state.endTime, 'end');
        this.state.editFormDisable = true;
        this.editFormDisable = true;
        this.state.renderKey = this.state.renderKey + 1;
      }
    }
  }

  checkFormIsEdited = () => {
    let isEdited = false;
    let isDayPresent = false;
    if (this.editFormDisable) {
      const { startTime, endTime, selectedDays, scheduleName } =
        this.editFormData;
      if (this.state.selectedDays.length || selectedDays.length) {
        this.state.selectedDays.map((day) => {
          if (!selectedDays.includes(day)) {
            isDayPresent = true;
          }
        });
      }
      if (
        startTime != this.state.startTime ||
        endTime != this.state.endTime ||
        scheduleName !== this.state.scheduleName ||
        this.state.enableSchedule != this.props.customEnabled ||
        selectedDays.length != this.state.selectedDays.length
      ) {
        isEdited = false;
      } else {
        isEdited = isDayPresent ? false : true;
      }
    }
    return isEdited;
  };

  findTargetView = () => {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      return 'Mobile';
    } else {
      return 'Desktop';
    }
  };

  convertTo12Hour(hour) {
    let hrs = hour.split(':');
    let hr = parseInt(hrs[0]);
    let m = hrs[1];

    let remainder = hr % 12;
    let h = remainder == 0 ? 12 : remainder;

    let ampm = hr < 12 ? 'AM' : 'PM';
    let value = h + ':' + m + ' ' + ampm;
    return value;
  }

  assignTime(time12h, type) {
    // time12h = this.convertTo12Hour(time12h);
    const [time, modifier] = this.convertTo12Hour(time12h).split(' ');

    // const [time, modifier] = time12h.split(' ');
    let ampm = modifier;
    let [hours, minutes] = time.split(':');

    if (hours === '00') {
      hours = '12';
      ampm = 'AM';
    }
    if (hours < 10) {
      hours = '0' + hours;
    }
    let fulltime = hours + ':' + minutes + ' ' + ampm;
    if (type === 'start') {
      this.setState({
        startHour: hours,
        startMinute: minutes,
        startAMPM: ampm,
        startTime: hours + ':' + minutes + ' ' + ampm,
      });
      this.editFormData.startTime = fulltime;
    } else {
      this.setState({
        endHour: hours,
        endMinute: minutes,
        endAMPM: ampm,
        endTime: hours + ':' + minutes + ' ' + ampm,
      });
      this.editFormData.endTime = fulltime;
    }

  }

  getScheduleNameOptions() {
    if (this.props.freeze === undefined) {
      return [];
    }
    let options = this.props.freeze.timeTemplates.map((t) => {
      return {
        value: t.id,
        displayValue: t.name,
      };
    });
    return options;
  }

  handleResetValue(value) {
    this.setState({
      resetValue: value,
      editFormDisable: this.editFormDisable,
    });
  }

  deleteScheduleHandler = (event) => {
    event.preventDefault();
    let payload = {
      name: this.state.scheduleName,
      shouldPause: undefined,
      schedules: [
        {
          startTime: this.convertTime12to24(this.state.startTime),
          endTime: this.convertTime12to24(this.state.endTime),
          daysOfWeek: this.findDaysOfWeek(this.state.selectedDays),
        },
      ],
    };
    this.props.onChangeFreezeDevice(
      'delete',
      this.props.devMac,
      'custom',
      payload,
      this.props.selectedEquipment
    );
    this.props.onCancel();
  };

  handleToggleEnableSchedule() {
    if (!this.state.enableSchedule) {
      this.setState({ enableSchedule: true });
    } else {
      this.setState({ enableSchedule: false });
    }

    this.setState({ editFormDisable: false });
  }

  handleClearSchedule() {
    this.setState({
      scheduleName: '',
      startHour: '12',
      endHour: '11',
      startMinute: '00',
      endMinute: '45',
      startAMPM: 'AM',
      endAMPM: 'PM',
      startTime: '12:00 AM',
      endTime: '11:45 PM',
      enableSchedule: false,
    });
  }

  handleScheduleNameChange(event) {
    this.setState({
      scheduleName: event.target.value,
      editFormDisable: false,
      isEditingName: true,
    });
  }

  handleClearScheduleName = () => {
    this.setState({
      scheduleName: '',
      isEditingName: false,
    });
  };

  enableEditing = async () => {
    await this.setState({
      isEditingName: true,
    });
    this.inputName.focus();
  };

  handleScheduleTimings() {
    const [endTime, endTimeModifier] = this.state.endTime.split(' ');
    let [endHours, endMinutes] = endTime.split(':');

    const [startTime, startTimeModifier] = this.state.startTime.split(' ');
    let [startHours, startMinutes] = startTime.split(':');
    let scheduleObject;
    endHours = endHours === '12' ? '00' : endHours;

    if (endTimeModifier === 'PM') {
      endHours = parseInt(endHours) + 12;
    }

    startHours = startHours === '12' ? '00' : startHours;

    if (startTimeModifier === 'PM') {
      startHours = parseInt(startHours) + 12;
    }
    let startTime24hFormat = this.convertTime12to24(this.state.startTime);
    let endTime24hFormat = this.convertTime12to24(this.state.endTime);
    if (
      (startTimeModifier === 'PM' && endTimeModifier === 'AM') ||
      endHours < startHours ||
      endTime24hFormat === startTime24hFormat ||
      endTime24hFormat < startTime24hFormat
    ) {
      scheduleObject = this.prepareMultiScheduleForApi();
    } else {
      scheduleObject = [
        {
          startTime: startTime24hFormat,
          endTime: endTime24hFormat,
          daysOfWeek: this.findDaysOfWeek(this.state.selectedDays),
        },
      ];
    }

    return scheduleObject;
  }

  prepareMultiScheduleForApi() {
    return [
      {
        startTime: this.convertTime12to24(this.state.startTime),
        endTime: '',
        daysOfWeek: this.findDaysOfWeek(this.state.selectedDays),
      },
      {
        startTime: '00:00',
        endTime: this.convertTime12to24(this.state.endTime),
        daysOfWeek: this.findDaysOfWeek(this.state.selectedDays, 'endTime'),
      },
    ];
  }

  convertTime12to24(time12h) {
    const [time, modifier] = time12h.split(' ');

    let [hours, minutes] = time.split(':');

    if (hours === '12') {
      hours = '00';
    }
    if (modifier === 'PM') {
      hours = parseInt(hours) + 12;
    }
    return `${hours}:${minutes}`;
  }

  addFormHandler = (event) => {
    if(this.props.isDeviceSuspend || !this.props.handleDeviceSteering({ 'customSchedules':this.handleScheduleTimings(),  'enable': this.state.enableSchedule  })){
    event.preventDefault();
    let payload = {
      name: this.state.scheduleName,
      shouldPause: undefined,
      enable: this.state.enableSchedule,
      schedules: this.handleScheduleTimings(),
    };
    this.props.onChangeFreezeDevice(
      'put',
      this.props.devMac,
      'custom',
      payload,
      this.props.selectedEquipment
    );
    this.props.updateScheduleDetails();
    }
    this.props.onCancel();
}

  findDaysOfWeek(selectedDays, timeType = '') {
    if (selectedDays == undefined) {
      return [];
    }
    if (timeType === 'endTime') {
      return selectedDays.map((day) =>
        day === 'sunday' ? 1 : this.days[day] + 1
      );
    }
    return selectedDays.map((day) => this.days[day]);
  }

  isNotValidAlphaNumeric(value) {
    const pattern = /^[a-zA-Z0-9]*$/;
    return !pattern.test(value);
  }
  isValidName(name) {
    let res;
    res = name.match('^[^<>$`\\\\^&;"\']+$');

    if (res == null) {
      return false;
    } else if (/\s+$/.test(name) || /^\s/.test(name)) {
      return false;
    } else {
      return true;
    }
  }

  updateScheduleName = () => {
    this.setState({
      isEditingName: false,
    });
  };

  confirmModalCancelHandler = () => {
    this.props.onCancel();
  };
  closeModal = () => {
    this.props.closeModal();
  };

  handleWeekDaysChange(selectedDays) {
    this.setState({
      selectedDays: selectedDays,
      editFormDisable: false,
    });
  }

  updateEndTime(h, m, apm) {
    let hour, minute, ampm;
    if (h !== 'HH') {
      hour = h;
      minute = this.state.startMinute;
      ampm = this.state.startAMPM;
    } else if (m !== 'MM') {
      hour = this.state.startHour;
      minute = m;
      ampm = this.state.startAMPM;
    } else if (apm !== 'AMPM') {
      hour = this.state.startHour;
      minute = this.state.startMinute;
      ampm = apm;
    }
    if (ampm === 'AM') {
      if (hour === '12') {
        if (minute === '45') {
          this.setState({
            endHour: '01',
            endAMPM: 'AM',
            endMinute: '00',
            endTime: '01:00 AM',
          });
        } else {
          minute = parseInt(minute) + 15;
          this.setState({
            endHour: hour,
            endAMPM: ampm,
            endMinute: minute,
            endTime: hour + ':' + minute + ' ' + ampm,
          });
        }
      } else {
        if (minute === '45') {
          if (hour === '11') {
            ampm = 'PM';
          }
          hour = parseInt(hour) + 1;
          if (hour < 10) {
            hour = '0' + hour;
          }

          this.setState({
            endHour: hour,
            endAMPM: ampm,
            endMinute: '00',
            endTime: hour + ':00 ' + ampm,
          });
        } else {
          minute = parseInt(minute) + 15;
          this.setState({
            endHour: hour,
            endAMPM: ampm,
            endMinute: minute,
            endTime: hour + ':' + minute + ' ' + ampm,
          });
        }
      }
    } else {
      if (hour === '12') {
        if (minute === '45') {
          this.setState({
            endHour: '01',
            endAMPM: 'PM',
            endMinute: '00',
            endTime: '01:00 PM',
          });
        } else {
          minute = parseInt(minute) + 15;
          this.setState({
            endHour: hour,
            endAMPM: ampm,
            endMinute: minute,
            endTime: hour + ':' + minute + ' ' + ampm,
          });
        }
      } else {
        if (minute === '45') {
          if (hour === '11') {
            ampm = 'AM';
          }
          hour = parseInt(hour) + 1;
          if (hour < 10) {
            hour = '0' + hour;
          }

          this.setState({
            endHour: hour,
            endAMPM: ampm,
            endMinute: '00',
            endTime: hour + ':00 ' + ampm,
          });
        } else {
          minute = parseInt(minute) + 15;
          this.setState({
            endHour: hour,
            endAMPM: ampm,
            endMinute: minute,
            endTime: hour + ':' + minute + ' ' + ampm,
          });
        }
      }
    }
  }

  // Converts 12-hour value to sortable order: 12->0, 1->1, ..., 11->11
  hrVal(h) {
    const n = parseInt(h);
    return n === 12 ? 0 : n;
  }

  // Checks if end time is before or equal to start time in same AM/PM period
  isEndBeforeStart(sHour, sMin, eHour, eMin) {
    const sv = this.hrVal(sHour) * 60 + parseInt(sMin);
    const ev = this.hrVal(eHour) * 60 + parseInt(eMin);
    return ev <= sv;
  }

  // Returns the next valid end time after the given start hour:minute
  getNextValidEnd(sHour, sMin, endAMPM) {
    const sMinInt = parseInt(sMin);
    if (sMin === '59') {
      const sVal = this.hrVal(sHour);
      const nextVal = sVal + 1;
      const nextHour = nextVal === 0 ? '12' : nextVal.toString().padStart(2, '0');
      return { endHour: nextHour, endMinute: '00', endTime: nextHour + ':00 ' + endAMPM };
    }
    const nextMinute = (sMinInt + 1).toString().padStart(2, '0');
    return { endHour: sHour, endMinute: nextMinute, endTime: sHour + ':' + nextMinute + ' ' + endAMPM };
  }

  handleStartTimeChange(event, value) {
    let h = 'HH';
    let m = 'MM';
    let ampm = 'AMPM';
    if (event === 'HH') {
      this.setState({ startHour: value });
      h = value;
    } else if (event === 'MM') {
      this.setState({ startMinute: value });
      m = value;
    } else if (event === 'AMPM') {
      this.setState({ startAMPM: value });
      ampm = value;
    }

    if (h !== 'HH' && h !== this.state.startHour) {
      const newStartTime = h + ':' + this.state.startMinute + ' ' + this.state.startAMPM;
      this.setState({ startHour: h, startTime: newStartTime });

      if (this.state.startAMPM === this.state.endAMPM) {
        if (this.isEndBeforeStart(h, this.state.startMinute, this.state.endHour, this.state.endMinute)) {
          const fix = this.getNextValidEnd(h, this.state.startMinute, this.state.endAMPM);
          this.setState(fix);
        }
      }
      if (this.state.startAMPM === 'AM' && h !== '12' && this.state.endHour === '12' && this.state.endAMPM === 'AM') {
        this.setState({ endAMPM: 'PM', endTime: this.state.endHour + ':' + this.state.endMinute + ' PM' });
      }
    }

    if (m !== 'MM' && m !== this.state.startMinute) {
      const newStartTime = this.state.startHour + ':' + m + ' ' + this.state.startAMPM;
      this.setState({ startMinute: m, startTime: newStartTime });

      if (this.state.startAMPM === this.state.endAMPM) {
        if (this.isEndBeforeStart(this.state.startHour, m, this.state.endHour, this.state.endMinute)) {
          const fix = this.getNextValidEnd(this.state.startHour, m, this.state.endAMPM);
          this.setState(fix);
        }
      }
    }

    if (ampm !== 'AMPM' && ampm !== this.state.startAMPM) {
      const newStartTime = this.state.startHour + ':' + this.state.startMinute + ' ' + ampm;
      this.setState({ startAMPM: ampm, startTime: newStartTime });


    }
    this.setState({ editFormDisable: false })
  }

  handleEndTimeChange(event, value) {
    let h = 'HH';
    let m = 'MM';
    let ampm = 'AMPM';
    if (event === 'HH') {
      this.setState({ endHour: value });
      h = value;
    } else if (event === 'MM') {
      this.setState({ endMinute: value });
      m = value;
    } else if (event === 'AMPM') {
      this.setState({ endAMPM: value });
      ampm = value;
    }

    if (h !== 'HH' && h !== this.state.endHour) {
      const newEndTime = h + ':' + this.state.endMinute + ' ' + this.state.endAMPM;
      this.setState({ endHour: h, endTime: newEndTime });
    }

    if (m !== 'MM' && m !== this.state.endMinute) {
      const newEndTime = this.state.endHour + ':' + m + ' ' + this.state.endAMPM;
      this.setState({ endMinute: m, endTime: newEndTime });
    }

    if (ampm !== 'AMPM' && ampm !== this.state.endAMPM) {
      const newEndTime = this.state.endHour + ':' + this.state.endMinute + ' ' + ampm;
      this.setState({ endAMPM: ampm, endTime: newEndTime });
    }
  }

  renderSelectOptions(type, from = '') {
    let values = [];
    let optionsHtml = [];
    if (type === 'hours') {
      values = [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
      ];
      //optionsHtml.push(<option >{'HH'}</option>);
    } else if (type === 'minutes') {
      values = ['00', '15', '30', '45'];
      //optionsHtml.push(<option >{'MM'}</option>);
    } else if (type === 'ampm') {
      values = ['AM', 'PM'];
    }

    values.map((val) => {
      if (from == 'end' && type === 'hours') {
        optionsHtml.push(<option value={val}>{val}</option>);

      } else {
        optionsHtml.push(<option value={val}>{val}</option>);

      }
    });

    return optionsHtml;
  }

  compareTime() {
    // console.log('st',this.state.startTime)
    // console.log('et',this.state.endTime)
  }

  isOvernightSchedule() {
    const start24 = this.convertTime12to24(this.state.startTime);
    const end24 = this.convertTime12to24(this.state.endTime);
    const [sH, sM] = start24.split(':').map(Number);
    const [eH, eM] = end24.split(':').map(Number);
    return (eH * 60 + eM) <= (sH * 60 + sM);
  }

  getOvernightSummary() {
    const dayAbbr = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const dayOrder = this.state.selectedDays
      .map(d => this.days[d])
      .sort((a, b) => a - b);
    if (!dayOrder.length) return '';
    return dayOrder.map(d => {
      const startDay = dayAbbr[d % 7];
      const endDay = dayAbbr[(d % 7 + 1) % 7];
      return `${startDay}→${endDay}`;
    }).join(', ');
  }

  calculateEstimatedDuration() {
    const startTime24 = this.convertTime12to24(this.state.startTime);
    const endTime24 = this.convertTime12to24(this.state.endTime);
    
    const [startHour, startMinute] = startTime24.split(':').map(Number);
    const [endHour, endMinute] = endTime24.split(':').map(Number);
    
    const startTotalMinutes = startHour * 60 + startMinute;
    const endTotalMinutes = endHour * 60 + endMinute;
    
    let diffMinutes = endTotalMinutes - startTotalMinutes;
    if (diffMinutes < 0) {
      diffMinutes += 24 * 60;
    }
    
    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;
    
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

  updateFocus = (val) => {
    this.setState({ isFocused: val });
  }

  confirmModalCancelHandler = () => {
    this.setState({ confirmModal: false, result: null });
  }

  openModal = () => {
    const modalContent = (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <span style={{ whiteSpace: 'pre-wrap', fontWeight: 'bold', textAlign: 'center' }}>
          {this.state.scheduleName}
        </span>
        <br />
        <span style={{ textAlign: 'center', fontWeight: 'normal' }}>
          Are you sure you want to delete this schedule?
        </span>
      </div>
    );
    this.setState({ confirmModal: true, result: modalContent });
  }

  checkForInvalidEndTime() {
    if (this.state.startTime === this.state.endTime) {
      return true;
    }
    if (this.state.endHour === '12' && this.state.endMinute === '00' && this.state.endAMPM === 'AM') {
      return true;
    }
    return false;
  }

  render() {
    // console.log('Pause Schedule Form :::', this.props);
    let compareTime, errMessage;

    compareTime = false;
    errMessage = '';

    let onOff = (
      <div style={{ marginLeft: '5px' }}>
        <Switch
          id="DeviceScheduleEnableToggle"
          aria-checked={this.state.enableSchedule}
          aria-label='enable schedule'
          onText='ENABLED'
          offText='DISABLED'
          onChange={this.handleToggleEnableSchedule}
          checked={this.state.enableSchedule}
        />
        {/* /> */}
      </div>
    );

    let estimatedDuration = this.calculateEstimatedDuration();
    // console.log('estimatedDuration :::',estimatedDuration);
    let InputPlaceholder = 'Enter the name';
    let form = (
      <div className={classes.PauseScheduleBody}>
        <Box>
          <div
            id="scheduleNameText"
            style={{ margin: '10px 0px 0px 10px', color: '#555555' }}
          >
            Schedule Name
          </div>
          <div
            className={classes.Input}
            style={{ padding: '2px 10px 10px 10px' }}
          >
            <input
              maxLength="30"
              ref={(d) => (this.inputName = d)}
              id="scheduleNameTextbox"
              aria-label="schedule name"
              type="text"
              className={classes.InputElement}
              value={this.state.scheduleName}
              onChange={this.handleScheduleNameChange}
              // disabled={!this.state.isEditingName}
              onFocus={() => this.updateFocus(true)}
              onBlur={() => this.updateFocus(false)}
              placeholder={InputPlaceholder}
            />
          </div>
          <div
            id="ScheduleNameErrorMsg"
            style={
              !this.isValidName(this.state.scheduleName) &&
                this.state.scheduleName.length > 0
                ? {
                  color: 'red',
                  fontSize: 12,
                  display: 'block',
                  paddingLeft: 10,
                }
                : { display: 'none' }
            }
          >
            Space is only allowed in between the characters. The following
            characters are not allowed $ {'<'} {'>'} ` \ ^ & ; " '
          </div>
        </Box>

        <Box>
          <div className={classes.Input}>
            <WeekDays
              name={this.props.devMac}
              handleResetValue={this.handleResetValue}
              resetValue={this.state.resetValue}
              from={'Groups'}
              handleClearSchedule={this.handleClearSchedule}
              handleWeekDaysChange={this.handleWeekDaysChange}
              selectedDays={this.state.selectedDays}
            />
          </div>

          <label style={{ color: 'red' }}> </label>
        </Box>

        <Box>
          <div id='PauseStartTime' style={{ margin: '10px 0px 0px 10px', color: '#555555' }}>
            Start Time

          </div>

          <div key={this.state.renderKey} className={classes.Input} style={{ display: 'flex' }}>
          <SelectDropdown
            id='STHH'
            className={classes.TimeSelector}
            value={hoursOptions.filter(option => option.value === this.state.startHour)[0]}
            defaultValue={hoursOptions.filter(option => option.value === this.state.startHour)[0]}
             data='HH'
             onChange={(option)=>this.handleStartTimeChange('HH', option.value)}
             options= {hoursOptions}
             customWidth='75px'
             />&nbsp;:&nbsp;
             <SelectDropdown
            id='STMM'
            className={classes.TimeSelector}
            value={minutesOptions.filter(option => option.value === this.state.startMinute)[0]}
            defaultValue={minutesOptions.filter(option => option.value === this.state.startMinute)[0]}
             disabled={this.state.startHour === 'HH' ? true : false}
             data='MM'
             onChange={(option)=>this.handleStartTimeChange('MM', option.value)}
              options={minutesOptions}
              customWidth='75px'
             />&nbsp;
             <SelectDropdown
            id='STAMPM'
            className={classes.TimeSelector}
             data='AMPM'
            value={ampmOptions.filter(option => option.value === this.state.startAMPM)[0]}
            defaultValue={ampmOptions.filter(option => option.value === this.state.startAMPM)[0]}
             disabled={(this.state.startHour === 'HH' || compareTime) ? true : false}
             onChange={(option)=>this.handleStartTimeChange('AMPM', option.value)}
              options={ampmOptions}
              customWidth='75px'
             />
          </div>

          <label style={{ color: 'red' }}> </label>
        </Box>

        <Box>
          <div id='PauseEndTime' style={{ margin: '10px 0px 0px 10px', color: '#555555' }}>
            End Time
          </div>

          <div key={this.state.renderKey} className={classes.Input} style={{ display: 'flex' }}>

          <SelectDropdown
            id='ETHH'
            className={classes.TimeSelector}
            data='HH'
            disabled={(this.state.startHour === 'HH' || compareTime) ? true : false}
            value={hoursOptions.filter(option => option.value === this.state.endHour)[0]}
            defaultValue={hoursOptions.filter(option => option.value === this.state.endHour)[0]}
             onChange={(option)=>this.handleEndTimeChange('HH', option.value)}
             options= {hoursOptions}
             customWidth='75px'
             />&nbsp;:&nbsp;
             <SelectDropdown
            id='ETMM'
            className={classes.TimeSelector}
            disabled={(this.state.endHour === 'HH' || compareTime) ? true : false}
            data='MM'
            value={minutesOptions.filter(option => option.value === this.state.endMinute)[0]}
            defaultValue={minutesOptions.filter(option => option.value === this.state.endMinute)[0]}
             onChange={(option)=>this.handleEndTimeChange('MM', option.value)}
              options={minutesOptions}
              customWidth='75px'
             />&nbsp;
             <SelectDropdown
           id='ETAMPM'
           className={classes.TimeSelector}
           disabled={(this.state.endHour === 'HH' || compareTime) ? true : false}
           data='AMPM'
            value={ampmOptions.filter(option => option.value === this.state.endAMPM)[0]}
            defaultValue={ampmOptions.filter(option => option.value === this.state.endAMPM)[0]}
             onChange={(option)=>this.handleEndTimeChange('AMPM', option.value)}
              options={ampmOptions}
              customWidth='75px'
             />

            <span className={classes.EstimatedDuration}>
              (Estimated Duration {estimatedDuration})
              {this.state.selectedDays.length > 0 && this.isOvernightSchedule() && !this.checkForInvalidEndTime() && (
                <div style={{ fontSize: '11px', color: '#888', marginTop: '2px' }}>
                  {this.getOvernightSummary()}
                </div>
              )}
            </span>
          </div>

          {this.checkForInvalidEndTime() && (
            <div style={{ color: 'red', fontSize: '12px', marginLeft: '10px', marginTop: '4px' }}>
              {this.state.endHour === '12' && this.state.endMinute === '00' && this.state.endAMPM === 'AM'
                ? 'End time cannot be 12:00 AM. Please select a different end time.'
                : 'Start and end time cannot be the same. Maximum schedule is 23 hours and 59 minutes.'}
            </div>
          )}
          <label style={{ color: 'red' }}> </label>
        </Box>

        <Box>
          <div className={classes.BodyRow} style={{ display: 'flex' }}>
            <div
              id="enableSchedule"
              style={{
                margin: '10px 0px 0px 10px',
                color: '#555555',
                display: 'flex',
              }}
            >
              Schedule Enabled {onOff}
            </div>
          </div>
        </Box>
        <Box>
          <div className={classes.Err}>{errMessage}</div>
          <div className={classes.BodyRow}>
            <div style={{ display: 'flex' }}>
              <div>
                <button
                  id="deleteSchedule"
                  disabled={
                    this.props.template &&
                      this.props.template.customSchedules &&
                      this.props.template.customSchedules.length
                      ? false
                      : true
                  }
                  className={classes.DeleteButton}
                  onClick={this.openModal}
                  btnType="Delete"
                >
                  Delete Schedule
                </button>
              </div>
              <div>

                <button
                  disabled={
                    this.state.scheduleName.length > 30 ||
                    !this.isValidName(this.state.scheduleName) ||
                    this.state.selectedDays.length === 0 ||
                    !this.state.startTime ||
                    !this.state.endTime ||
                    compareTime ||
                    this.checkFormIsEdited() ||
                    this.checkForInvalidEndTime()
                  }
                  id="saveschedule"
                  className={classes.Button}
                  onClick={this.addFormHandler}
                  btnType="Success"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </Box>
      </div>
    );

    if (this.props.loading) {
      form = <Spinner />;
    }

    const { confirmModal, result } = this.state;

    return (
      <React.Fragment>
        <div className={classes.CreatePauseScheduleForm}>
          <span
            id="CancelScheduleForm"
            onClick={this.closeModal}
            style={{ float: 'right', color: '#555555', cursor: 'pointer' }}
          >
            X
          </span>
          <strong>Pause Schedule </strong>
          <button
            id="clearSchedule"
            className={classes.RegularButton}
            style={{ fontSize: '13px' }}
            onClick={() => {
              this.handleResetValue(true);
            }}
          >
            <FaSync /> Reset
          </button>
          {form}
        </div>
        {
          confirmModal &&
          (<Modal
            deviceGroupConfirmation
            show={confirmModal}
            modalClosed={this.confirmModalCancelHandler}
          >
            <Confirm
              deviceGroupConfirmation
              result={result}
              confirm={this.deleteScheduleHandler}
              cancel={this.confirmModalCancelHandler}
              cancelButtonLabel="Cancel"
              confirmButtonLabel="Proceed"
              hideActionText
            />
          </Modal>)
        }
      </React.Fragment>
    );
  }
}


const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChangeFreezeDevice: (putDelete, devMac, templateID, template, selectedEquipment) => {
      dispatch(
        actions.changeFreezeDevice(putDelete, devMac, templateID, template, selectedEquipment)
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(PauseScheduleForm, axios));
